export const getInstructorsFromVspPageData = (vspPageData: any) => {
  const allInstructors = vspPageData.map((course: any) => course.instructors).flat();
  const seenIds = new Set<string>();

  return allInstructors.filter((instructor: any) => {
    if (seenIds.has(instructor.id)) {
      return false;
    }
    seenIds.add(instructor.id);
    return true;
  });
};
